import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Text } from 'foundations-components/components/Text';
import LoadingPropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/LoadingPropertyValue';
import EmptyPropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/EmptyPropertyValue';
import PropertySection from 'framework-asset-preview-lib/internal/properties/components/propertySections/PropertySection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StatisticPropertySection({
  crmObject,
  formatStyle,
  getValue,
  loadingStatistics,
  properties,
  propertyName,
  statisticObject,
  direction = 'row',
  valueAlignment = 'right',
  truncateLabel
}) {
  const translationKey = `frameworkAssetPreviewLib.propertyLabel.${crmObject.objectTypeId}.${propertyName}`;
  const renderLabel = useCallback(() => loadingStatistics ? /*#__PURE__*/_jsx(LoadingPropertyValue, {}) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: translationKey
  }), [loadingStatistics, translationKey]);
  return /*#__PURE__*/_jsx(PropertySection, {
    crmObject: crmObject,
    direction: direction,
    properties: properties,
    propertyName: propertyName,
    renderLabel: isValidI18nKey(translationKey) ? renderLabel : undefined,
    renderValue: () => {
      if (loadingStatistics) {
        return /*#__PURE__*/_jsx(LoadingPropertyValue, {});
      }
      const value = getValue();
      if (value == null && !statisticObject) {
        return /*#__PURE__*/_jsx(EmptyPropertyValue, {});
      }
      return /*#__PURE__*/_jsx(Text, {
        as: "div",
        textAlign: valueAlignment === 'right' ? 'end' : 'start',
        children: /*#__PURE__*/_jsx(FormattedNumber, {
          value: value,
          precision: 2,
          style: formatStyle
        })
      });
    },
    truncateLabel: truncateLabel
  });
}